import { render } from "./Mint.vue?vue&type=template&id=e7cd56d8"
import script from "./Mint.vue?vue&type=script&lang=js"
export * from "./Mint.vue?vue&type=script&lang=js"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__